import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'jubi_starred_events';

function readFromStorage() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
  } catch {
    return [];
  }
}

function useStarredEvents() {
  const [starredEvents, setStarredEvents] = useState(readFromStorage);

  // Farklı bileşen instance'larını (RightPanelBody, RightPanelToolbar) senkronize tut
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY) {
        setStarredEvents(readFromStorage());
      }
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  const toggleStar = useCallback((event) => {
    setStarredEvents((prev) => {
      const id = String(event.EVEID);
      const exists = prev.some((e) => String(e.EVEID) === id);
      const snapshot = {
        EVEID: event.EVEID,
        TICID: event.TICID,
        FNAME: event.FNAME,
        TDESC: event.TDESC,
        FVALUE: event.FVALUE,
        ANDAT: event.ANDAT,
        position: event.position,
        member: event.member,
        starredAt: new Date().toISOString(),
      };
      const next = exists
        ? prev.filter((e) => String(e.EVEID) !== id)
        : [snapshot, ...prev];
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      // Diğer instance'ları storage event ile uyar
      window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY }));
      return next;
    });
  }, []);

  const isStarred = useCallback(
    (eventId) => starredEvents.some((e) => String(e.EVEID) === String(eventId)),
    [starredEvents],
  );

  const unstar = useCallback((eventId) => {
    setStarredEvents((prev) => {
      const next = prev.filter((e) => String(e.EVEID) !== String(eventId));
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
      window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY }));
      return next;
    });
  }, []);

  const clearAll = useCallback(() => {
    localStorage.removeItem(STORAGE_KEY);
    window.dispatchEvent(new StorageEvent('storage', { key: STORAGE_KEY }));
    setStarredEvents([]);
  }, []);

  return { starredEvents, toggleStar, isStarred, unstar, clearAll };
}

export default useStarredEvents;
